import React from "react";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { useUserState } from "store/user-store";
import { useGetSupportedTimezones } from "api/api-hooks/user-hooks";
import { recordToSelectItems } from "utils/utils";
import { logInfo } from "utils/logging-utils";
import "./UserProfileTzSelect.scss"

export default function UserProfileTzSelect() {
  const displayTimezone = useUserState((state) => state.getDisplayTimezone());
    const setDisplayTimezone = useUserState((state) => state.setDisplayTimezone);

    const tzSelectData = useGetSupportedTimezones()
    const timezoneSelections = recordToSelectItems(tzSelectData.data)

    logInfo("display tz ", displayTimezone);


    const onDisplayTzChange = (e: DropdownChangeEvent) => {
        logInfo("Setting display timezone to ", e.value);
        setDisplayTimezone(e.value);
    }

    if(!timezoneSelections) {
        return <div>Loading timezones...</div>
    }

    return <div>
      <Dropdown placeholder="Select Display Timezone"
        className="tz-select w-full"
        value={displayTimezone}
        options={timezoneSelections}
        filter
        filterMatchMode="contains"
        onChange={onDisplayTzChange}
        optionValue="value"
    />
    </div>
}